import React from "react";
import styled from "styled-components";
import { Asset, Box, Text, utils } from "@thenounproject/lingo-core";
import assetFileDetails from "../assetFileDetails";

const { getTextColor, getColorBasedOnLightness } = utils;

export const MetaWrapper = styled(Box).attrs({
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
})``;

type Props = {
  asset: Asset;
  background?: string;
};

const DefaultMeta = ({ asset, background }: Props) => {
  const primaryTextColor = getTextColor(background || "#ffffff");
  const secondaryTextColor = getColorBasedOnLightness(
    background || "#ffffff",
    "grayDarkest",
    "grayLightest"
  );
  return (
    <MetaWrapper key="meta-element">
      <Box>
        <Text font="ui.regular" color={primaryTextColor} maxLines={2}>
          {asset?.name || asset.colors[0]?.name || "Unnamed asset"}
        </Text>
      </Box>
      <Box>
        <Text font="ui.small" color={secondaryTextColor}>
          {assetFileDetails(asset)}
        </Text>
      </Box>
    </MetaWrapper>
  );
};

export default DefaultMeta;
